import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { FMessage, iFMessage } from '../../hoc/IntlComponents';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import LandingApiRequests from '../../components/TransferApi/LandingApiRequests';
import VKApiRequests from '../../components/TransferApi/VKApiRequests';
import FBApiRequests from '../../components/TransferApi/FBApiRequests';
import ApiRequests from '../../components/TransferApi/ApiRequests';
import { useCardNavTabsWithRoutes } from '../../components/Card/cardHelpers';

const tabKeys = {
  orders: 1,
  'orders-vk': 2,
  'orders-fb': 3,
  api: 4,
};

const navs = intl => [
  <a
    className="nav-link"
    title={iFMessage({intl, id: 'transfer-by-api.nav.landing.title'})}
  >
    <FMessage id="transfer-by-api.nav.landing.title"/>
  </a>,
  <a
    className="nav-link"
    title={iFMessage({intl, id: 'transfer-by-api.nav.vk.title'})}
  >
    <FMessage id="transfer-by-api.nav.vk.title"/>
  </a>,
  <a
    className="nav-link"
    title={iFMessage({intl, id: 'transfer-by-api.nav.fb.title'})}
  >
    <FMessage id="transfer-by-api.nav.fb.title"/>
  </a>,
  <a
    className="nav-link"
    title={iFMessage({intl, id: 'transfer-by-api.nav.api.title'})}
  >
    <FMessage id="transfer-by-api.nav.api.title"/>
  </a>,
];

const TransferRequestByIPPage = ({ intl, api_key, history }) => {
  const { activeTab, handleTabChange } = useCardNavTabsWithRoutes({tabKeys, history});

  return (
    <Layout formattedTitle="pages.transfer-request-by-api.title">
      <Layout.Col className='transfer-api'>
        <Card.NavTabs
          navItems={navs(intl)}
          tabProps={{api_key, history}}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        >
          <LandingApiRequests type='landings'/>
          <VKApiRequests type='vk'/>
          <FBApiRequests type='fb'/>
          <ApiRequests type='api'/>
        </Card.NavTabs>
      </Layout.Col>
    </Layout>
  );
};

const mapStateToProps = ({webmaster}) => ({
  api_key: webmaster.profile.api_key,
});

export default connect(
  mapStateToProps,
)(injectIntl(TransferRequestByIPPage));
